import { useRef } from "react";
import Toast from "../ErrorBoundry/Toast";
import { FileData } from "./VInputUpload";
import { IconCloudUpload2 } from "../../assests/icons/Icons";
import { Progress } from "../Upload/Progress";


export interface NewFileUploadProps {
    name: string;
    isrequired?: boolean;
    handlePreviewClick: (file: File | string) => void;
    isSingle?: boolean;
    label?: string;
    acceptType?: string;
    filenames: FileData[];
    error?: string;
    helpertext?: string;
    helperupload?: string;
    disable?: boolean;
    onFileChange: (name: string, files: FileData[]) => void;
    maxSize: number;
    btnLabel?: string;
}

const NewFileUpload = ({ name, isrequired, handlePreviewClick, isSingle, label, acceptType, filenames, error, helpertext, helperupload, disable, onFileChange, maxSize, btnLabel, }: NewFileUploadProps) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    const handleClear = (fileName: string) => {
        if (disable) return;
        const updatedFiles = filenames.filter((file) => file.name !== fileName);
        onFileChange(name, updatedFiles);
    };

    const fileHandler = (files: FileList | null) => {
        if (files && files.length > 0) {
            const newFiles: FileData[] = [];
            const maxSizeInBytes = maxSize * 1024 * 1024;

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const fileExtension = file.name.includes(".")
                    ? `.${file.name
                        .substring(file.name.lastIndexOf(".") + 1)
                        .toLowerCase()
                        .trim()}`
                    : "";

                if (acceptType && !acceptType.includes(fileExtension)) {
                    inputRef.current && (inputRef.current.value = "");
                    Toast({
                        messageText: `Please select valid ${acceptType}`,
                        messageType: "E",
                        toastId: "fileerr",
                    });
                    return;
                }

                if (file.size <= maxSizeInBytes) {
                    newFiles.push({
                        name: file.name,
                        icon: file.name.split(".").pop()?.toUpperCase() || "",
                        file: file,
                    });
                } else {
                    inputRef.current && (inputRef.current.value = "");
                    Toast({
                        messageText: "File should not exceed the limit",
                        messageType: "W",
                        toastId: "File",
                    });
                }
            }

            onFileChange(name, newFiles);
        }
    };

    return (
        <div className="w-full flex flex-col gap-2">
            {/* LABEL */}
            {label && (
                <label className={`label-box6 ${error && "label-error"}`}>
                    {label}{isrequired && (<span className="text-rose-400 text-[1.125rem] ">*</span>)}
                </label>
            )}

            {/* SINGLE MODE */}
            {isSingle && filenames?.length === 0 ? (
                <div className="relative">
                    <div  className={`flex items-center justify-between border border-dashed rounded-lg px-4 py-4 bg-[#FCFCFD] transition  ${error ? "border-rose-400" : "border-gray-300"} ${disable ? "opacity-60 cursor-not-allowed" : "hover:border-gray-400"} `}  >
                        {/* LEFT SIDE */}
                        <div className="flex items-center gap-4">
                            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 text-gray-500">
                                <IconCloudUpload2 className={`size-6 ${error ? "fill-red-400" : "fill-[#000000]"}`} />
                            </div>

                            <div>
                                <p className={`text-sm font-medium text-gray-800 ${error && "text-red-400"}`}>
                                    Choose a file or drag & drop here
                                </p>
                                <p className={`text-xs text-gray-400 ${error && "text-red-400"}`}>{helperupload ? helperupload : `Max ${maxSize}MB • ${acceptType}`}</p>
                            </div>
                        </div>

                        {/* RIGHT BUTTON */}
                        <button type="button" disabled={disable} className={`text-sm font-normal border border-[#616161] px-4 py-1.5 rounded-md bg-white hover:bg-gray-100 transition ${error && "border-red-400 text-red-400"}`} >
                            {btnLabel || "Select file"}
                        </button>

                    </div>

                    <input  ref={inputRef}   disabled={disable} type="file" accept={acceptType} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={(e) => fileHandler(e.target.files)} />
                </div>
            ) : (
                <div className="mt-2">
                    {Array.isArray(filenames) && filenames.map((file, i) => (
                        <Progress key={i} title="Click to Preview" disable={disable}  name={file.name} icon={file.icon}
                            file={file.file}  //   fieldname={name}
                            handleClear={() => handleClear(file.name)} handlePreviewClick={handlePreviewClick} />
                    ))}
                </div>
            )}

            {/* ERROR */}
            <div className="min-h-5 overflow-hidden">
                {error && (<span className={`label-box1 label-error relative w-fit`}>{error}</span>)}
                {!error && helpertext && (<span className="helper-box1 relative !pt-0">{helpertext}</span>)}

            </div>
        </div>
    );
};

export default NewFileUpload;